exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".InputFilter {\n  z-index: 10;\n  cursor: pointer; }\n  .InputFilter .Icon {\n    float: right;\n    padding: 4px 0 0 6px; }\n    .InputFilter .Icon svg {\n      width: 14px;\n      height: 14px;\n      fill: url(#nav-gradient); }\n  .InputFilter__Wrap {\n    float: left; }\n  .InputFilter__Dropdown {\n    width: 140px;\n    left: auto; }\n", ""]);

// exports
